// src/pages/Users.js
import { useState, useEffect } from "react";
import axios from "axios";
import { BACKEND_BASE } from "./constant";
import "./Users.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Premium = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BACKEND_BASE}/getPremiumUsers`);
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const formatESTDate = (timestamp) => {
    if (!timestamp) return "N/A";
    const date = new Date(timestamp);
    return date.toLocaleString("en-US", {
      timeZone: "America/New_York",
      hour12: true,
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  };

  const renderValue = (value, field) => {
    if (value === null || value === undefined) return "N/A";

    if (field === "Plan") return value?.plan || "N/A";
    if (field === "AppliedAt")
      return value?.appliedAt ? formatESTDate(value.appliedAt) : "N/A";
    if (field === "Questionnaire")
      return value?.questionnaire ? JSON.stringify(value.questionnaire) : "N/A";

    if (Array.isArray(value)) return value.join(", ");
    if (typeof value === "object") return JSON.stringify(value);

    return value;
  };

  return (
    <div className="admin-container">
      <Button
        className="sticky-back-button"
        onClick={() => navigate("/")}
        style={{ backgroundColor: "rgb(72, 39, 110)" }}
      >
        Back
      </Button>

      {loading ? (
        <p className="text-center my-2">Loading...</p>
      ) : data.length > 0 ? (
        <div className="table-container">
          <table className="styled-table">
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email</th>
                <th>Gender</th>
                <th>Age</th>
                <th>Intention</th>
                <th>Height</th>
                <th>Job Title</th>
                <th>Personality</th>
                <th>Hobbies</th>
                <th>Drinks</th>
                <th>Plan</th>
                <th>Applied At</th>
                <th>Questionnaire</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item._id}>
                  <td>{item.firstName || "N/A"}</td>
                  <td>{item.lastName || "N/A"}</td>
                  <td>{item.email || "N/A"}</td>
                  <td>{item.gender || "N/A"}</td>
                  <td>{item.age || "N/A"}</td>
                  <td>{item.intention || "N/A"}</td>
                  <td>{item.height || "N/A"}</td>
                  <td>{item.jobTitle || "N/A"}</td>
                  <td>
                    {Array.isArray(item.personality)
                      ? item.personality.join(", ")
                      : "N/A"}
                  </td>
                  <td>
                    {Array.isArray(item.hobbies)
                      ? item.hobbies.join(", ")
                      : "N/A"}
                  </td>
                  <td>{item.drinks || "N/A"}</td>
                  <td>{renderValue(item.premium, "Plan")}</td>
                  <td>{renderValue(item.premium, "AppliedAt")}</td>
                  <td>{renderValue(item.premium, "Questionnaire")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>Empty Data</p>
      )}
    </div>
  );
};

export default Premium;
